import { setMwValue, getMwValue, setMwToken, getMwToken } from './utils';
import {API_PROD_URL, API_URL} from './application';

const LOANS_GET_URL = API_PROD_URL+'api/Loans?dtStart='
// const LOANS_GET_URL = API_URL+'api/Loans?dtStart='
const LOANS_POST_URL  = API_URL+'api/Loans'
const LOANS_MATCH_URL = API_URL+'api/Loans/TryMatchAccountTransaction?id='
const LOANS_REMOVE_URL = API_URL+'api/Loans/TryDeleteAccountTransaction?id='
const LOANREPORT_GET_URL = API_URL+'api/Loans/GetLoanReport?dtStart='
const INVOICE_LOANPAYMENT_POST_URL = API_URL+'api/LoanPayments/InvoicePayment';
const INVOICE_AND_SEND_LOANPAYMENT_POST_URL = API_URL+'api/LoanPayments/InvoiceAndSendPayment';
const REMINDER_LOANPAYMENT_POST_URL = API_URL+'api/LoanPayments/InvoicePaymentReminder';
const SEND_LOANDOCUMENT_POST_URL = API_URL+'api/Loans/DocumentRequest';
const SEND_INVOICE_POST_URL = API_URL+'api/LoanPayments/SendInvoice';
const SEND_REMINDER_POST_URL = API_URL+'api/LoanPayments/SendReminder';

export const REQUEST_LOANS = 'REQUEST_LOANS'
export const RECEIVE_LOANS_SUCCESS = 'RECEIVE_LOANS_SUCCESS'
export const RECEIVE_LOANS_ERROR = 'RECEIVE_LOANS_ERROR'

export const REQUEST_INVOICE_PAYMENT = 'REQUEST_INVOICE_PAYMENT'
export const RECEIVE_INVOICE_PAYMENT_SUCCESS = 'RECEIVE_INVOICE_PAYMENT_SUCCESS'
export const RECEIVE_INVOICE_PAYMENT_ERROR = 'RECEIVE_INVOICE_PAYMENT_ERROR'


export const REQUEST_INVOICE_REMINDER = 'REQUEST_INVOICE_REMINDER'
export const RECEIVE_INVOICE_REMINDER_SUCCESS = 'RECEIVE_INVOICE_REMINDER_SUCCESS'
export const RECEIVE_INVOICE_REMINDER_ERROR = 'RECEIVE_INVOICE_REMINDER_ERROR'

export const REQUEST_LOANDOCUMENT = 'REQUEST_LOANDOCUMENT'
export const RECEIVE_LOANDOCUMENT_SUCCESS = 'RECEIVE_LOANDOCUMENT_SUCCESS'
export const RECEIVE_LOANDOCUMENT_ERROR = 'RECEIVE_LOANDOCUMENT_ERROR'

export const REQUEST_INVOICE_SEND = 'REQUEST_INVOICE_SEND'
export const RECEIVE_INVOICE_SEND_SUCCESS = 'RECEIVE_INVOICE_PAYMENT_SEND'
export const RECEIVE_INVOICE_SEND_ERROR = 'RECEIVE_INVOICE_PAYMENT_SEND'


export const REQUEST_REMINDER_SEND = 'REQUEST_REMINDER_SEND'
export const RECEIVE_REMINDER_SEND_SUCCESS = 'RECEIVE_REMINDER_PAYMENT_SEND_SUCCESS'
export const RECEIVE_REMINDER_SEND_ERROR = 'RECEIVE_REMINDER_PAYMENT_SEND_ERROR'


export const REQUEST_LOANREPORT = 'REQUEST_LOANREPORT'
export const RECEIVE_LOANREPORT_SUCCESS = 'RECEIVE_LOANREPORT_SUCCESS'
export const RECEIVE_LOANREPORT_ERROR = 'RECEIVE_LOANREPORT_ERROR'

export const REQUEST_LOANS_MATCH = 'REQUEST_LOANS_MATCH'
export const RECEIVE_LOANS_MATCH_SUCCESS = 'RECEIVE_LOANS_MATCH_SUCCESS'
export const REQUEST_LOANS_REMOVE = 'REQUEST_LOANS_REMOVE'
export const RECEIVE_LOANS_REMOVE_SUCCESS = 'RECEIVE_LOANS_REMOVE_SUCCESS'
export const REQUEST_LOANS_SAVE = 'REQUEST_LOANS_SAVE'
export const RECEIVE_LOANS_SAVE_SUCCESS = 'RECEIVE_LOANS_SAVE_SUCCESS'
export const RECEIVE_LOANS_SAVE_ERROR = 'RECEIVE_LOANS_SAVE_ERROR'

export function postLoanAccountTransaction(loanAccountTransaction) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOANS_SAVE, LoanAccountTransaction: loanAccountTransaction});        
         return fetch(LOANS_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...loanAccountTransaction
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_LOANS_SAVE_SUCCESS, loanAccountTransaction: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function postSendInvoice(invoiceRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_SEND, invoiceRequest: invoiceRequest});        
         return fetch(SEND_INVOICE_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoiceRequest
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_SEND_SUCCESS, invoiceResponse: {...invoiceRequest, ...response} })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}



export function postSendReminder(invoiceRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_REMINDER_SEND, invoiceRequest: invoiceRequest});        
         return fetch(SEND_REMINDER_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoiceRequest
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_REMINDER_SEND_SUCCESS, invoiceResponse: {...invoiceRequest, ...response} })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function documentRequest(documentRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOANDOCUMENT, loanDocumentRequest: documentRequest});        
         return fetch(SEND_LOANDOCUMENT_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({   
                Id: documentRequest.id,
                DocumentTypeEnum: documentRequest.documentTypeEnum,
                StartDate: documentRequest.startDate
            }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_LOANDOCUMENT_SUCCESS, loanDocumentResponse: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function postInvoicePayment(invoiceRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_PAYMENT, invoiceRequest: invoiceRequest});        
         return fetch(INVOICE_LOANPAYMENT_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoiceRequest
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_PAYMENT_SUCCESS, invoiceResponse: {...invoiceRequest, ...response} })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function postInvoiceAndSendPayment(invoiceRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_PAYMENT, invoiceRequest: invoiceRequest});        
         return fetch(INVOICE_AND_SEND_LOANPAYMENT_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoiceRequest
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_PAYMENT_SUCCESS, invoiceResponse: {...invoiceRequest, ...response} })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}




export function postInvoiceReminder(invoiceRequest) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_REMINDER, invoiceRequest: invoiceRequest});        
         return fetch(REMINDER_LOANPAYMENT_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoiceRequest
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_REMINDER_SUCCESS, invoiceResponse: {...invoiceRequest, ...response} })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function tryDeleteAccountTransaction(id) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOANS_REMOVE, trn: id});        
         return fetch(LOANS_REMOVE_URL+id, {
            method: 'GET',
            headers: {      
                'authorization' : 'bearer '+token
              }
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_LOANS_REMOVE_SUCCESS, id: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function getFetchLoans (dtStart)  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOANS});        
         return fetch(LOANS_GET_URL+dtStart, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_LOANS_SUCCESS, loans: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchLoanreport ()  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOANREPORT});        
         return fetch(LOANREPORT_GET_URL, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_LOANREPORT_SUCCESS, report: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}